export const container = {
    marginBottom: '3.625rem',
    position: 'relative',
};

export const input = ({ theme: { colors }, active, hasError, textArea }) => ({
    backgroundColor: colors.form.bgGrey,
    border: `1px solid ${active && !hasError ? colors.cyan : colors.form.borderGrey}`,
    width: '100%',
    padding: '1.375rem 1.125rem 0.75rem 1.125rem',
    fontSize: '1.125rem',
    boxSizing: 'border-box',
    ...(textArea && {
        whiteSpace: 'pre-wrap',
        lineHeight: '1.5rem',
        resize: 'vertical',
    }),
});

export const border = ({ theme: { colors }, active, hasError }) => ({
    background: hasError ? colors.red : colors.cyan,
    willChange: 'height',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) height 0.125s',
    height: active ? '0.1875rem' : 0,
    boxShadow: !hasError ? `0px 3px 5px 0px ${colors.cyan}` : 'none',
});

export const label = () => ({
    width: '100%',
    position: 'relative',
    display: 'block',
});

export const labelText = ({ theme: { colors }, active, value, hasError }) => ({
    color: hasError && active ? colors.red : colors.darkGrey,
    position: 'absolute',
    top: active || value ? '0.5rem' : '1.3rem',
    left: '1.125rem',
    fontSize: active || value ? '0.75rem' : '1.125rem',
    transition:
        'cubic-bezier(0.4, 0.0, 0.2, 1) width 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) top 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) font-size 0.3s',
    willChange: 'font-size, bottom',
});

export const errors = ({ theme: { colors } }) => ({
    position: 'absolute',
    fontSize: '0.75rem',
    left: '1.125rem',
    color: colors.red,
    bottom: '-1.5rem',
});
